/**************************************************************************************************/
/*   File: /src/app/shared/models/dossier.change.status.ts                                        */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Monday April 1st 2019                                                          */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Mon May 06 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The dossier change status
 */
export class DossierChangeStatus {
    /**
     * The dossier id
     */
    dossierId: number;
    /**
     * The motivation
     */
    motivation?: string;
}